import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://2d8ba626433064f59b1e4d880f29c4df@o4510891961810944.ingest.us.sentry.io/4510891971903488",
  sendDefaultPii: true,
  enableLogs: true,
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  tracesSampleRate: 0.3,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: window.location.hostname.includes("lovable") ? "preview" : "production",
  enabled: !window.location.hostname.includes("localhost"),
});

export default Sentry;
